export default function Page404(){
    return(
        <div className="flex-shrink-0 modular min-vh-100">
            404
        </div>
    )
}